import $names               from "rapid/getModulesNames.helper";

import {external}           from "./external";
import template             from "./app.html";
import {AppController}      from "./app.controller";

import {ConfigsModule}      from "./config/config";
import {BootstrapModule}    from "./bootstrap/bootstrap";
import {ComponentsModule}   from "./components/components";
import {ServicesModule}     from "./services/services";

import {DirectivesModule}   from "./directives/directives.module";
import {UtilityModule}      from "./utility/utility";

import {FiltersModule}      from "./filters/filters";

angular
	.module("app", external.concat($names([
		ConfigsModule,
		BootstrapModule,
		ComponentsModule,
		ServicesModule,
		DirectivesModule,
		UtilityModule,
		FiltersModule
	])))
	.value("$routerRootComponent", "app")
	.component("app", {
		template,
		controller: AppController,
		controllerAs: "app"
	});


// WEBPACK FOOTER //
// ./sources/app.js